export default __webpack_public_path__ + "static/Tori-Cooper-hero-mobile-34ed82fb9770519c1d16abaf57bedb29.jpg";